const bullLinkToDownload = (url: string) => {
  const id = url.split('/')[5];
  return `https://drive.google.com/uc?export=download&id=${id}`;
};

export default bullLinkToDownload;